module.exports = __webpack_public_path__ + "static/media/06.5318e4c5.jpg";